import React, { useState, useEffect, useCallback } from 'react';
import API from '../services/api';
import Modal from '../components/Modal';

const bugun = () => { const d = new Date(); const p = n => String(n).padStart(2,'0'); return `${d.getFullYear()}-${p(d.getMonth()+1)}-${p(d.getDate())}`; };
const trTarih = s => s ? new Date(s).toLocaleDateString('tr-TR') : '—';
const trTutar = v => (v ?? 0).toLocaleString('tr-TR', { minimumFractionDigits: 2 });

export default function Harcamalar() {
  const [bas, setBas] = useState(bugun());
  const [bit, setBit] = useState(bugun());
  const [data, setData] = useState(null);
  const [yukleniyor, setYukleniyor] = useState(true);
  const [modal, setModal] = useState(null);
  const [modalYukleniyor, setModalYukleniyor] = useState(false);

  const yukle = useCallback((b, s) => {
    setYukleniyor(true);
    API.get('/Finans/harcamalar', { params: { bas: b, bit: s } })
      .then(r => setData(r.data))
      .catch(() => setData(null))
      .finally(() => setYukleniyor(false));
  }, []);

  useEffect(() => { yukle(bas, bit); }, []); // eslint-disable-line

  return (
    <div>
      <h1 className="sayfa-baslik">Harcamalar</h1>
      <p className="sayfa-alt">Dönemsel gider listesi.</p>

      <form onSubmit={e => { e.preventDefault(); yukle(bas, bit); }}
            style={{ display:'flex', gap:12, alignItems:'flex-end', flexWrap:'wrap', marginBottom:18 }}>
        <div className="form-row"><div className="form-label">Başlangıç</div>
          <input type="date" className="input" value={bas} onChange={e => setBas(e.target.value)} /></div>
        <div className="form-row"><div className="form-label">Bitiş</div>
          <input type="date" className="input" value={bit} onChange={e => setBit(e.target.value)} /></div>
        <button className="btn" type="submit">Listele</button>
      </form>

      {!yukleniyor && data && (
        <div style={{ display:'flex', gap:8, flexWrap:'wrap', marginBottom:14 }}>
          <span className="bilgi-rozet">📋 {data.liste.length} kayıt</span>
          <span className="bilgi-rozet" style={{ fontWeight:700, color:'#c0392b' }}>Toplam: {trTutar(data.toplam)} ₺</span>
        </div>
      )}

      <div className="kart" style={{ overflow:'hidden' }}>
        {yukleniyor ? <div className="bos-durum">Yükleniyor…</div>
          : !data || data.liste.length === 0 ? <div className="bos-durum">Bu dönemde harcama bulunamadı.</div>
          : (
          <table className="tablo">
            <thead><tr>
              <th style={{ width:110 }}>Tarih</th>
              <th style={{ width:80 }}>Saat</th>
              <th style={{ width:140, textAlign:'right' }}>Tutar</th>
            </tr></thead>
            <tbody>
              {data.liste.map((r, i) => (
                <tr key={i} onClick={async () => {
                  setModalYukleniyor(true);
                  try {
                    const res = await API.get(`/Finans/chi/${r.id}`);
                    setModal(res.data);
                  } catch {
                    setModal(r);
                  } finally {
                    setModalYukleniyor(false);
                  }
                }} style={{ cursor:'pointer' }}>
                  <td>{trTarih(r.tar)}</td>
                  <td style={{ color:'var(--metin-soluk)' }}>{r.saat || '—'}</td>
                  <td style={{ textAlign:'right', fontWeight:600, color:'#c0392b' }}>{trTutar(r.tutar)} ₺</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {modal && (
        <Modal baslik="Harcama Detayı" onKapat={() => setModal(null)}>
          <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
            <div><strong>Tarih:</strong> {trTarih(modal.tar)}</div>
            <div><strong>Saat:</strong> {modal.saat || '—'}</div>
            <div><strong>Tutar:</strong> {trTutar(modal.tutar)} ₺</div>
            {modal.harcAciklama && <div><strong>Açıklama:</strong> {modal.harcAciklama}</div>}
            {modal.harcKat && <div><strong>Harcama Kategorisi:</strong> {modal.harcKat}</div>}
          </div>
        </Modal>
      )}
    </div>
  );
}
